export const guestUserAllowedQueryList = [
  'customDomainRuntimeInfo',
  'decryptLoginLink',
  'linkAction',
  'stampDocumentSignRequest',
  'updateStampDocumentSignRequestWithSignature',
  'templateDocumentSignRequest',
  'updateTemplateDocumentSignRequestWithSignature',
  'publicTradeDataCodes',
  'createDocument',
  'updateDocument',
  'deleteDocument',
  'document',
  'searchDocuments',
  'usIor',
  // This mutation requires a JWT as an argument so it is safe to allow for guests
  'migrateUser',
];
